import IconDrake from './IconDrake'

export default IconDrake;